import RichTextEditor from 'react-rte';
import { questions } from '../../../../../dictionaries/questionsAndGroups';

export const defaultState = {
  cb_current_org: {
    id: null,
    answer: {},
  },
  cb_changes: {
    id: null,
    answer: {},
  },
  cb_organisation_stability: {
    id: null,
    answer: {},
  },
  cb_financial_viability: {
    id: null,
    answer: {},
  },
  complaints_appeals: {
    id: null,
    answer: {},
  },
  candidate_feedback: {
    id: null,
    answer: {},
  },
  status_gc: {
    id: null,
    answer: {},
  },
  performance_satisfaction: {
    id: null,
    answer: {},
  },
  satisfaction_level_gc: {
    id: null,
    answer: {},
  },
  scheme_path_assessment_changes: {
    id: null,
    answer: {},
  },
  assessors: {
    id: null,
    answer: {
      answerComplex: {
        ica: {},
        nfa: {},
        nla: {},
        npa: {},
      },
    },
  },
  development_plan: {
    id: null,
    answer: {},
  },
  workshop_dates: {
    id: null,
    answer: {},
  },
  workshop_agenda: {
    id: null,
    answer: {},
  },
  management_reveiews: {
    id: null,
    answer: {},
  },
  internal_audits: {
    id: null,
    answer: {},
  },
  competence_baseline_4lc: {
    id: null,
    answer: {},
  },
  cb_cert_capability_al: {
    id: null,
    answer: {
      answerComplex: [{ language: '', certLevels: '' }],
    },
  },
  cspp: {
    id: null,
    answer: {
      answerComplex: [],
    },
  },

  organisation_stability: null,
  financial_viability: null,
  performance_satisfaction_group: null,
  quality_certification_process: null,
  compliance_quality_assurance: null,
  national_competence_baseline: null,
  cb_capability_additional_languages: null,
  certification_system_panel_participation: null,
  errors: {},
};

const UPDATE_FIELD = 'UPDATE_FIELD';
const SET_ERRORS = 'SET_ERRORS';
const SET_INITIAL_STATE = 'SET_INITIAL_STATE';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });
export const setErrorsCreator = (payload) => ({ type: SET_ERRORS, payload });
export const setInitialStateCreator = (payload) => ({ type: SET_INITIAL_STATE, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_INITIAL_STATE) {
    if (
      action.payload[questions.cbCurrentOrg]?.answer?.answerString &&
      typeof action.payload[questions.cbCurrentOrg].answer.answerString === 'string'
    ) {
      action.payload[
        questions.cbCurrentOrg
      ].answer.answerString = RichTextEditor.createValueFromString(
        action.payload[questions.cbCurrentOrg].answer.answerString,
        'html',
      );
    }

    if (
      action.payload[questions.developmentPlan]?.answer?.answerString &&
      typeof action.payload[questions.developmentPlan].answer.answerString === 'string'
    ) {
      action.payload[
        questions.developmentPlan
      ].answer.answerString = RichTextEditor.createValueFromString(
        action.payload[questions.developmentPlan].answer.answerString,
        'html',
      );
    }

    if (
      action.payload[questions.workshopAgenda]?.answer?.answerString &&
      typeof action.payload[questions.workshopAgenda].answer.answerString === 'string'
    ) {
      action.payload[
        questions.workshopAgenda
      ].answer.answerString = RichTextEditor.createValueFromString(
        action.payload[questions.workshopAgenda].answer.answerString,
        'html',
      );
    }

    return { ...state, ...action.payload };
  }

  if (action.type === UPDATE_FIELD) {
    switch (action.payload.dataType) {
      case 'file':
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: {
              ...state[action.payload.name].answer,
              file: action.payload.value,
              deleteFile: action.payload.value === null,
            },
          },
        };
      case 'number':
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: { ...state[action.payload.name].answer, answerNumber: action.payload.value },
          },
        };
      case 'boolean':
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: { ...state[action.payload.name].answer, answerBool: action.payload.value },
          },
        };
      case 'string':
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: { ...state[action.payload.name].answer, answerString: action.payload.value },
          },
        };
      case 'status':
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            status: action.payload.value,
          },
        };
      case 'comment':
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: {
              ...state[action.payload.name].answer,
              answerComment: action.payload.value,
            },
          },
        };
      case 'assessor':
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: {
              ...state[action.payload.name].answer,
              answerComplex: {
                ...state[action.payload.name].answer.answerComplex,
                [action.payload.category]: {
                  ...state[action.payload.name].answer.answerComplex?.[action.payload.category],
                  [action.payload.type]: action.payload.value,
                },
              },
            },
          },
        };
      case 'complex_add_row':
        const existingComplex = state[action.payload.name].answer.answerComplex || [];
        existingComplex.push(action.payload.row);

        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: {
              ...state[action.payload.name].answer,
              answerComplex: existingComplex,
            },
          },
        };
      case 'complex_remove_row':
        const updatedComplex = state[action.payload.name].answer.answerComplex || [];
        updatedComplex.splice(action.payload.rowIndex, 1);
        return {
          ...state,
          [action.payload.name]: {
            ...state[action.payload.name],
            answer: {
              ...state[action.payload.name].answer,
              answerComplex: updatedComplex,
            },
          },
        };
      default:
        break;
    }
  }

  if (action.type === SET_ERRORS) {
    return { ...state, errors: action.payload };
  }

  return state;
}
